import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { BehaviorSubject } from 'rxjs';
import { ImageGallery } from '../type/employee.interface';
import { ChatAttachments } from './chat-http.service';

@Injectable({
  providedIn: 'root'
})
export class GalleryImageService {
  images$: BehaviorSubject<ImageGallery[]> = new BehaviorSubject<ImageGallery[]>([]);
  stateVisible = new BehaviorSubject(false);
  openImageIndex = 0;
  constructor(private httpService: HttpService) {}

  closeGallery() {
    this.stateVisible.next(false);
    this.images$.next([]);
    this.openImageIndex = 0;
  }

  openChatGallery(images: ChatAttachments[], index: number) {
    const gallery = images.map(item => {
      const image: ImageGallery = {
        imageUrl: item.AttachURL,
        id: item.AttachID,
        state: item.AttachState,// 'Approved' | 'Moderation' | 'Declined';
        name: item.AttachName,
      }
      return image;
    });
    this.images$.next(gallery);
    this.openImageIndex = index;
    this.stateVisible.next(true);
  }

  openGallery(images: string[], index: number) {
    const gallery = images.map(item => {
      const image: ImageGallery = {
        imageUrl: item,
      }
      return image;
    });
    this.images$.next(gallery);
    this.openImageIndex = index;
    this.stateVisible.next(true);
  }
}
